export function createPageSnapshot(location, title) {
  return Object.freeze({
    path: `${location.pathname || '/'}${location.search || ''}`,
    url: location.href,
    title,
  });
}

export function createSessionPathTracker({ isTracked, markTracked }) {
  const inFlightPaths = new Set();

  return async function runOnce(path, work) {
    if (isTracked(path) || inFlightPaths.has(path)) {
      return false;
    }

    inFlightPaths.add(path);
    try {
      await work();
      markTracked(path);
      return true;
    } finally {
      inFlightPaths.delete(path);
    }
  };
}
